import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { AppBar, Button, Icon, makeStyles, Toolbar, Typography } from '@material-ui/core'
import AddContent from './AddContent'
import ListContent from './ListContent'
import digikapitaalLogo from '../../media/digi-kapitaal-nobg.png'
import schoolmakersLogo from '../../media/schoolmakers-black.svg'
import { appSubdomainVar, isUserLoggedInVar } from '../../graphql/stores/local'
import useAuthenticated from '../../hooks/useAuthenticated'
import { SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME } from '../../constants'

const routes = ['/', '/login']

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1,
  },
  logoIcon: {
    width: '32px',
    marginRight: theme.spacing(2),
    height: 'auto',
  },
}))

const Navigation = () => {
  const { t, i18n } = useTranslation()
  const subdomain = useReactiveVar(appSubdomainVar)
  const history = useHistory()
  const classes = useStyles()
  const location = useLocation()
  const { signOut } = useAuthenticated()
  const isUserLoggedIn = useReactiveVar(isUserLoggedInVar)
  const titleText =
    subdomain === SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME ? 'Schoolleiderschap' : 'DigiKapitaal'
  const logo = subdomain === SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME ? schoolmakersLogo : digikapitaalLogo
  return (
    <AppBar color={'primary'} position={'relative'}>
      <Toolbar>
        {routes.indexOf(location.pathname) === -1 && (
          <img src={logo} className={classes.logoIcon} alt="logo" width="32px" height="auto" />
        )}
        <Typography variant="h6" className={classes.title}>
          {titleText}
        </Typography>
        {/*{!isUserLoggedIn && location.pathname !== '/login' && (
          <Button color={'inherit'} startIcon={<Icon children={'login'} />} href="/login">
            {t('Login')}
          </Button>
        )}*/}
        <div style={{ display: 'none' }}>
          <Button
            color={'inherit'}
            onClick={() => {
              i18n.changeLanguage('en')
            }}
          >
            EN
          </Button>
          <Button
            color={'inherit'}
            onClick={() => {
              i18n.changeLanguage('nl')
            }}
          >
            NL
          </Button>
        </div>
        <ListContent />
        <AddContent />
        {isUserLoggedIn ? (
          <Button
            color={'inherit'}
            startIcon={<Icon children={'logout'} />}
            onClick={() => {
              signOut()
              history.push(`/`)
            }}
          >
            {t('Logout')}
          </Button>
        ) : (
          ''
        )}
      </Toolbar>
    </AppBar>
  )
}

export default Navigation
